var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerWithEggInDiWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5792 11.6781C75.1255 12.5061 74.0541 12.9312 73.0457 12.6851L71.7097 12.3494C67.974 13.8004 67.1126 15.1525 67 19.5V80.3538C67 82.4461 65.4173 84 63.0603 84H15.5059C13.1363 84 11 82.4461 11 80.3538L10.6415 8.21071C10.6415 6.68907 10.1121 5.33419 9.15416 4.05869C8.64999 3.09648 9.44406 2 10.6415 2H60.4288C65.8108 2 70.9534 3.958 74.6591 7.40407C76.0078 8.48936 76.3859 10.2348 75.5792 11.6781Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 54L61.0197 53.9771C63.2153 53.9771 65 52.8182 65 51.3923V38.2222C46.1083 37.7952 36.1218 36 12 36L12 51.4076C12 52.841 13.7847 54 15.992 54Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41.4V78.8492C12 80.5965 13.7831 82.0092 15.9885 82L60.9763 81.9721C63.17 81.9721 65 80.498 65 78.76V37.08C65 36.764 64.9765 36.316 65 36C46.4887 36.1394 37.8205 41.4 12 41.4Z",
    fill: "#66CEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 33L61.0197 32.9771C63.2153 32.9771 65 31.8182 65 30.3923V17.2222C46.1083 16.7952 36.1218 15 12 15L12 30.4076C12 31.841 13.7847 33 15.992 33Z",
    fill: "#33BEF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.4V57.8492C12 59.5965 13.7831 61.0092 15.9885 61L60.9763 60.9721C63.17 60.9721 65 59.498 65 57.76V16.08C65 15.764 64.9765 15.316 65 15C46.4887 15.1394 37.8205 20.4 12 20.4Z",
    fill: "#66CEF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6736 54.3133C54.7438 40.5133 45.9438 33 40 33C34.0562 33 25.2562 40.5133 23.3264 54.3133C21.4737 68.1133 27.572 79 40 79C52.428 79 58.5263 68.1133 56.6736 54.3133Z",
    fill: "url(#paint0_radial_10219_28690)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 65.9216,
    rx: 10.7368,
    ry: 10.3725,
    fill: "url(#paint1_radial_10219_28690)",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C15 8.44772 15.4477 8 16 8H25C25.5523 8 26 8.44772 26 9C26 9.55228 25.5523 10 25 10H17V22H25C25.5523 22 26 22.4477 26 23C26 23.5523 25.5523 24 25 24H17V36H25C25.5523 36 26 36.4477 26 37C26 37.5523 25.5523 38 25 38H17V50H25C25.5523 50 26 50.4477 26 51C26 51.5523 25.5523 52 25 52H17V64H25C25.5523 64 26 64.4477 26 65C26 65.5523 25.5523 66 25 66H17V78H25C25.5523 78 26 78.4477 26 79C26 79.5523 25.5523 80 25 80H16C15.4477 80 15 79.5523 15 79V65V51V37V23V9Z",
    fill: "#668BA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 13,
    height: 73,
    rx: 3,
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10219_28690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 56) rotate(90) scale(23 17)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECB1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10219_28690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 65.9216) rotate(90) scale(10.3725 10.7368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerWithEggInDiWater);
export default __webpack_public_path__ + "static/media/beaker_with_egg_in_di_water.7582b4b9d963aee481fbf580e22ccb07.svg";
export { ForwardRef as ReactComponent };